import * as types from '../actions/actionTypes';

const initState = {
    list: [],
    selectItem: {},
};

export default function (state = initState, action) {
    switch(action.type) {
        case types.SAVE_TEMPLATE_LIST:
            return { ...state, list: action.data };
        case types.SAVE_TEMPLATE_ITEM:
            return { ...state, selectItem: action.data };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/templateReducer.js